import React from 'react';
import { connect } from 'react-redux';

import CartTrigger from '../components/CartTrigger';
import { toggleCartVisibility } from '../actions';

const mapStateToProps = state => {
  return {
    totalItems: state.currentOrder.total_quantity,
    isOpen: state.isOpen,
    hasViolation: state.currentOrder.violations.length > 0,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleCartVisibility: () => dispatch(toggleCartVisibility()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartTrigger);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/CartTrigger.js